module.exports = __webpack_public_path__ + "img/ic_badge_premium.d86c2bfa.svg";